// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

if (typeof GOOGLE_ANALYTICS_ID !== "undefined") {
  window.dataLayer = window.dataLayer || []
  function gtag() {
    dataLayer.push(arguments)
  }
  gtag("js", new Date())
  gtag("config", GOOGLE_ANALYTICS_ID)

  // taken from https://dev.to/tylerlwsmith/using-google-analyticss-gtagjs-with-turbolinks-5coa
  let isInitialLoad = true
  $(document).on("turbolinks:load", () => {
    if (isInitialLoad) {
      isInitialLoad = false
      return
    }
    gtag("config", GOOGLE_ANALYTICS_ID, {
      page_path: window.location.pathname,
    })
  })
}

import { Chart } from "chart.js"

Chart.defaults.font.size = 12
Chart.defaults.color = "#C1C6D0"
Chart.defaults.font.weight = "normal"
Chart.defaults.borderColor = "#E4E9ED"

import "bootstrap"

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
// Re-run event detection now that window.Turbolinks exists. The UJS module
// initializes (and calls detectEvents) before Turbolinks.start() runs, so it
// falls back to DOMContentLoaded. This call tears down that listener and
// replaces it with the correct turbolinks:load handler.
ReactRailsUJS.detectEvents()
ActiveStorage.start()

import "choices.js/public/assets/styles/choices.min.css"

import "../stylesheets/application.scss"

import "jquery-form/dist/jquery.form.min"

import "controllers"

// The imported version is vendor'd from the bundled gem. There were version
// mismatches with the npm packages so this is slightly clunky, but works for
// React 17 and the latest compatible version of the react-rails gem
import ReactRailsUJS from "../lib/react_ujs_gem_version.js"

// The ReactRailsUJS is added to the window so manual mount calls can be made
// By default, the mount call only fires for dom loaded events, not when content
// is loaded into the document via ajax calls (or other means). This is only an
// issue for hybrid pages, and for full react take overs this isn't a concern.
window.ReactRailsUJS = ReactRailsUJS
import normalizedContext from "../components/normalizedContext"

ReactRailsUJS.useContext(normalizedContext)

// When the browser restores a page from the bfcache (back/forward navigation),
// turbolinks:load does NOT fire — only the native `pageshow` event does.
// Without this handler, React components on pages with turbolinks-cache-control: no-cache
// would appear blank on back navigation because react-rails never remounts them.
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    ReactRailsUJS.mountComponents()
  }
})

import * as bootstrap from "bootstrap"
$(document).on("turbolinks:load", () => {
  $(document)
    .find('[data-bs-toggle="tooltip"]')
    .each((i, e) => {
      new bootstrap.Tooltip(e)
    })
})

$(window).on("scroll", function () {
  var scrollHeight = $(document).height()
  var scrollPos = $(window).height() + $(window).scrollTop()
  if ((scrollHeight - 300 >= scrollPos) / scrollHeight == 0) {
    $("html").trigger("load-more")
  }
})

import Cookies from "js-cookie"

window.setCID = (cid) => {
  if (cid) {
    Cookies.set("cid", cid)
  } else {
    Cookies.remove("cid")
  }
}
